import React, { ReactNode, useEffect } from "react";
import { useRouter } from "next/router";
import { scrollToElementByIdFromHash } from "@vahak/core-ui/dist/methods/dom";

import TopNavLayout from "../top-nav-layout/TopNavLayout";
import TopNavV2 from "../top-nav-v2";
import { APP_DOWNLOAD_BANNER_SECTION_ID } from "../../homepage-v2/app-download-banner/AppDownloadBannerV2";

interface WebV2LayoutProps {
    children: ReactNode;
}

const WebV2Layout = ({ children }: WebV2LayoutProps) => {
    const router = useRouter();

    useEffect(() => {
        scrollToElementByIdFromHash(router.asPath, APP_DOWNLOAD_BANNER_SECTION_ID);
    }, [router.asPath]);

    return <TopNavLayout navContent={<TopNavV2 />}>{children}</TopNavLayout>;
};

export default WebV2Layout;
